import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import Authorized from "components/Authorized";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import GroupModal from "routes/admin/components/GroupModal";
import GroupService from "services/Group";
import { invalidateGroupsQuery, useGroupsTable } from "hooks/useGroupsTable";

export const GROUPS_TABLE_CONSTANTS = {
  tableName: "groups_table",
  queryKey: "groups-table",
  className: "groups_table",
  exportTableName: null,
  header: "Groups",
  headerIcon: "users",
};

const CREATE_ACLS = [ACL_RELATIONSHIPS.adminGroup.create];

const GroupsTableV3 = () => {
  const { columns } = useGroupsTable();

  const fetchGroups = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await GroupService.getTable(nextQueryParams);

        return response;
      } catch (error) {
        console.error("Error fetching groups:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      queryKey={GROUPS_TABLE_CONSTANTS.queryKey}
      className={GROUPS_TABLE_CONSTANTS.className}
      tableName={GROUPS_TABLE_CONSTANTS.tableName}
      header={GROUPS_TABLE_CONSTANTS.header}
      headerIcon={GROUPS_TABLE_CONSTANTS.headerIcon}
      createButton={
        <Authorized permissions={CREATE_ACLS}>
          <GroupModal />
        </Authorized>
      }
      fetchData={fetchGroups}
      invalidateData={invalidateGroupsQuery}
      enableSearch
    />
  );
};

export default GroupsTableV3;
